<div [formGroup]="parts">

  <textarea formControlName="textValue"   cols="40" rows="5" (change)="changeDate()" ></textarea>

</div>

